import { ComparisonPageTemplate } from '@/components/ComparisonPageTemplate'
import { getCompetitor } from '@/data/compare'

export default function SquarespaceComparePage() {
  return <ComparisonPageTemplate competitor={getCompetitor('squarespace')} />
}
